/* eslint-disable max-lines-per-function */
import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip } from '@material-ui/core';
import { useProperties } from '~/properties';
import { useAmenityTypes } from '../../api/amenity-types';
import { useAmenityTags } from '../../api/amenity-tags';
import Dimmer from '+/Dimmer';
import EnhancedTable from '../orders/components/EnhancedTable';
import { useReadAmenityNotes, useDeleteAmenityNotes, useFetchUnitTypeMappings } from '../../api/orders';
import { getState } from '../../store';
import { getUnitType, getSource, formatDate } from '../orders/utils/utils';
import Form from './Form';
import orderBy from 'lodash/orderBy';
import {
    Dropdown
} from 'semantic-ui-react';


const ListOrders = () => {

    const { data: properties } = useProperties();

    const { data: amenity_tags, isFetchingAmenityTags } = useAmenityTags();
    const { data: amenity_types, isFetchingAmenityType } = useAmenityTypes();
    const [propertyId, setPropertyId] = React.useState(0);
    const { data: orders, isFetching } = useReadAmenityNotes(propertyId);
    const { data: unitTypeMappings, isFetchingUnitType } = useFetchUnitTypeMappings();
    const { mutate: deleteAmenityNotes } = useDeleteAmenityNotes();

    const [modalOpen, setModalOpen] = React.useState(false);
    const [bulkInsert, setBulkInsert] = React.useState(false);
    const [currentOrder, setCurrentOrder] = React.useState(null);
    const { role } = getState().auth;

    const isNotUser = role !== 'user';

    const openModal = useCallback(order => {
        setCurrentOrder(order || {});
        setModalOpen(true);
    }, [setCurrentOrder, setModalOpen]);

    const closeModal = useCallback(() => {

        setCurrentOrder({});
        setModalOpen(false);
    }, [setCurrentOrder, setModalOpen]);

    const style_Modal = {
        position: 'absolute',
        top: '50px',
        left: '50%',
        transform: 'translate(-50%, -0%)',
        width: bulkInsert ? '90%' : 800,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4
    };

    const columns = [
        {
            Header: 'Unit',
            accessor: 'unit_space_name'
        },
        {
            Header: 'Unit Type',
            accessor: 'unit_type'
        },
        {
            Header: 'Source',
            accessor: 'source'
        },
        {
            Header: 'Name',
            accessor: 'amenity_name',
            minWidth: 250
        },
        {
            Header: 'Manager Notes',
            accessor: 'manager_notes'
        },
        {
            Header: 'Owner Notes',
            accessor: 'owner_notes'
        },
        {
            Header: 'Ordered',
            accessor: 'ordered'
        },
        {
            Header: 'Amount',
            accessor: 'total_current'
        },
        {
            Header: 'Paid',
            accessor: 'paid'
        },
        {
            Header: 'Date Paid',
            accessor: 'date_paid'
        },
        {
            Header: 'Date Ordered',
            accessor: 'date_ordered'
        },
        {
            Header: 'Check',
            accessor: 'check_number'
        },
        {
            Header: () => 'Actions',
            id: 'actions',
            Cell: ({ row }) => {


                const SelectIcon = icon => {
                    if (icon === 'none'){
                        if (isNotUser){
                            return <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>;
                        }

                        return <></>;

                    }
                    if (icon === 'Delete' && isNotUser){
                        return (

                            <Tooltip title='Delete'>
                                <IconButton onClick={() => {

                                    const payload = {
                                        property_id: row.original.property_id,
                                        amenity_name: row.original.amenity_name,
                                        unit_space_name: row.original.unit_space_name,
                                        created_at: row.original.created_at
                                    };

                                    deleteAmenityNotes(payload);

                                }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>);


                    }
                    if (icon === 'Clean' && isNotUser){
                        return (
                            <Tooltip title='Clean'>
                                <IconButton onClick={() => {

                                    const payload = {
                                        property_id: row.original.property_id,
                                        amenity_name: row.original.amenity_name,
                                        unit_space_name: row.original.unit_space_name,
                                        created_at: row.original.created_at
                                    };

                                    deleteAmenityNotes(payload);

                                }}>
                                    <CleaningServicesIcon />
                                </IconButton>
                            </Tooltip>
                        );
                    }
                };

                const SelectAlert = row => {


                    if (
                        row.icon === 'Delete' && (
                            !row.isCustom
                            && !row.inEntrata
                        )
                    ){
                        return (

                            <Tooltip title='This entry was deleted in Entrata'>
                                <IconButton >
                                    <AnnouncementIcon style={{ fill: '#ffcc2f' }}/>
                                </IconButton>
                            </Tooltip>
                        );
                    }

                    return <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>;

                };

                return (

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>

                        <div>
                            { SelectAlert(row.original) }
                        </div>
                        <div>
                            <Tooltip title='Edit' onClick={() => {

                                openModal(row.original);
                            }}>
                                <IconButton>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        </div>

                        <div>
                            { SelectIcon(row.original.icon) }
                        </div>

                    </div>
                );
            }
        }
    ];

    if (isFetching || isFetchingUnitType || isFetchingAmenityType || isFetchingAmenityTags) return <Dimmer />;

    // const orders_array = Object.values(orders);

    const inEntrataBase = orders.inEntrata;

    const notInEntrata = orders.notInEntrata || [];

    const allUnits = orders.allUnits;
    const unitTypeMappings2 = orders.unitTypeMappings;

    const arrayAll = orderBy(notInEntrata.concat(inEntrataBase), ['unit_space_name']) || [];
    const lookup_code = arrayAll[0]?.lookup_code || 'pmaha';
    const ordersWithUnitType = arrayAll.map(element => {

        const { inEntrata, isCustom, isClean } = getSource(element, inEntrataBase, notInEntrata);

        const paid = value => {

            if (value === undefined) {
                return '';
            }

            if (value === true){
                return 'Yes';
            }

            return 'No';
        };

        let source = 'Custom';
        let icon = 'none';
        let color = 'black';

        if (inEntrata) {
            source = 'Entrata';

            if (!isClean) {
                icon = 'Clean';
            }
        }
        else {

            icon = 'Delete';

            if (!isCustom) {

                source = 'Entrata';
                color = '#aaa';
            }
        }


        return ({
            unit_type: `${getUnitType(element, unitTypeMappings)}`,
            ...element,
            source,
            paid: paid(element.paid),
            date_paid: formatDate(element.date_paid),
            date_ordered: formatDate(element.date_ordered),
            ordered: formatDate(element.ordered),
            color,
            icon,
            inEntrata,
            isCustom,
            isClean
        });
    });


    const subjects = [];
    (properties || []).map(property => {


        const value = {
            key: property.id,
            text: property?.name,
            value: property.id
        };
        subjects.push(value);

        return subjects;
    });

    return (
        <div>
            <div>
                <Dropdown style={ {
                    padding: '18px',
                    color: '#002143',
                    minWidth: '849px',
                    fontSize: '13px'
                }}
                id='form-type'
                placeholder='Select Property'
                options={subjects}
                selection
                onChange={(e, { value }) => {
                    setPropertyId(value);
                }}
                value={propertyId || ''}
                />


                {/* <FormControl fullWidth>
                    <InputLabel
                        style={{ color: '#002143' }}
                    >
                        Property Names
                    </InputLabel>
                    <Select
                        label='Property Name'
                        onChange={e => setPropertyId(e.target.value)}
                        defaultValue={propertyId || ''}
                    >
                        {
                            (properties || []).map((property, i) => (
                                <MenuItem key={i} value={ property.id }>{property?.name}</MenuItem>
                            ))
                        }

                    </Select>
                </FormControl> */}

            </div>


            {propertyId
                ? (<div style={{
                    marginTop: 20,
                    borderStyle: 'groove',
                    borderWidth: '1px'

                }}>
                    <CssBaseline />
                    <EnhancedTable
                        columns={columns}
                        data={ordersWithUnitType.flat()}
                        setModalOrdersOpen={() => openModal()}
                    />
                </div>)
                : ''}

            <Modal
                open={modalOpen}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box sx={style_Modal}>
                    <Form
                        // eslint-disable-next-line no-sequences
                        setModalOpen={() => (setBulkInsert(), closeModal())}
                        initialValues={currentOrder}
                        role={role}
                        lookup_code={lookup_code}
                        unitTypeMappings={unitTypeMappings2}
                        arrayAll={arrayAll}
                        allUnits={allUnits}
                        propertyId={propertyId}
                        amenity_tags={amenity_tags}
                        amenity_types={amenity_types}
                        bulkInsert={bulkInsert}
                        toggleBulkInsert={() => setBulkInsert(!bulkInsert)}
                    />
                </Box>
            </Modal>


        </div>
    );
};

export default ListOrders;
